'use client';

import { LogoRegister, LogoSlogan, LogoText } from '@/components/common';
import CommonNav from '@/components/layouts/CommonNav';
import Link from 'next/link';

import './InfoPages.css'; // 👈 add this
import { LogoLinks } from '@/components/common/smartguy-logo';

export default function InfoPages({ data }) {
  return (
    <main className="flex h-screen w-full flex-col items-center overflow-y-auto bg-white">
      <div className="">
        <div className="flex flex-col items-center justify-center">
          <Link href="/" className={`flex flex-col items-center justify-center`}>
            <div className="flex">
              <LogoText className="text-3xl" />
              <LogoRegister />
            </div>
            <LogoSlogan className="me-4 text-center text-[.7rem]" />
          </Link>

          <LogoLinks />
        </div>
        <div className="">
          <CommonNav />
        </div>
      </div>

      <div className="container mx-auto max-w-6xl space-y-4 rounded-sm bg-white p-4 shadow-sm">
        {data && (
          <div>
            <h1 className="text-primary mb-7 text-3xl font-bold">{data?.title}</h1>
            <div className="prose">
              <div dangerouslySetInnerHTML={{ __html: data.content }} />
            </div>
          </div>
        )}
      </div>
    </main>
  );
}
